
document.addEventListener("DOMContentLoaded", function() {

    const searchDropdown = document.querySelector('.xo-predictive-search'); 
    
    //const announcementBar = document.querySelector('.sc-bOQUxc.cnplnS.__pf.__pf_5JTsEohF'); 
    const announcementBar = document.querySelector('.sc-jeyqhx.jfeuyL.__pf.__pf_5JTsEohF'); 

    if (!searchDropdown || !announcementBar) return;


    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {

            const isSearchOpen = window.getComputedStyle(searchDropdown).display !== 'none' && 
                                 window.getComputedStyle(searchDropdown).visibility !== 'hidden';

            if (isSearchOpen) {

                announcementBar.style.opacity = '0';
                announcementBar.style.pointerEvents = 'none'; 
            } else {

                announcementBar.style.opacity = '1';
                announcementBar.style.pointerEvents = 'auto';
            }
        });
    });


    observer.observe(searchDropdown, { attributes: true, attributeFilter: ['style', 'class'] });
});